/**
 * Tapping Study Buddy opens this medium pop-up: four big gradient tiles in
 * the same look as MyGurukul.
 */
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { MessageSquareText, MessageCircleHeart, Users, NotebookPen, ArrowRight } from 'lucide-react';
import { BuddyAvatar } from '@/components/BuddyRoster';

export function BuddyMenu({ open, onOpenChange, buddyId, buddyName, noteReady, onPick }) {
  const tiles = [
    { id: 'feedback', label: 'Share Feedback', tagline: 'Tell us what to make better.', icon: MessageSquareText, gradient: 'from-pink-500 via-rose-500 to-orange-400' },
    { id: 'safespace', label: 'Safe Space Chat', tagline: 'Talk about anything, privately.', icon: MessageCircleHeart, gradient: 'from-sky-500 via-indigo-500 to-violet-600' },
    { id: 'roster', label: 'Meet All My Friends', tagline: 'Pick the buddy you like best.', icon: Users, gradient: 'from-emerald-500 via-teal-500 to-cyan-500' },
    { id: 'note', label: 'Take Note', tagline: noteReady ? 'I\'ll jot down the key points.' : 'Start a chat, then I can take notes.', icon: NotebookPen, gradient: 'from-amber-400 via-orange-500 to-rose-500' },
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-3xl p-5 sm:p-6" data-testid="buddy-menu">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full overflow-hidden ring-2 ring-amber-100 flex-shrink-0">
            <BuddyAvatar buddyId={buddyId} mood="happy" size={48} />
          </div>
          <div>
            <DialogTitle className="font-heading text-lg font-bold text-slate-900">Hi! What shall we do?</DialogTitle>
            <DialogDescription className="font-body text-xs text-slate-500">{buddyName ? `${buddyName} is here to help.` : 'Your buddy is here to help.'}</DialogDescription>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 mt-4">
          {tiles.map(t => (
            <button key={t.id} onClick={() => onPick(t.id)} data-testid={`buddy-menu-${t.id}`}
              className={`relative overflow-hidden rounded-2xl p-4 text-left text-white bg-gradient-to-br ${t.gradient} shadow-md hover:shadow-xl hover:-translate-y-0.5 active:scale-[0.98] transition-[transform,box-shadow] group ${t.id === 'note' && !noteReady ? 'opacity-80' : ''}`}>
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-white/10 rounded-full blur-xl pointer-events-none" />
              <div className="relative flex items-start justify-between">
                <t.icon className="w-7 h-7 text-white/90" strokeWidth={1.75} />
                <ArrowRight className="w-4 h-4 text-white/70 group-hover:translate-x-0.5 transition-transform" />
              </div>
              <p className="relative mt-4 font-display text-base sm:text-lg font-bold leading-tight">{t.label}</p>
              <p className="relative mt-0.5 text-[11px] font-body text-white/85 leading-snug">{t.tagline}</p>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default BuddyMenu;
